import { useTranslations } from "use-intl";
import { isConfig2Project } from "@/config";

/**
 * Brand vocabulary. tripleclick (config 2) names usage and win/loss differently
 * from the other brands, in every language, so both wordings sit side by side
 * under `terms` in the catalogs.
 *
 * "อัตราหักโควตา" is the factor a provider's win/loss is multiplied by before it
 * consumes the winning quota (100% = full deduction, 50% = the reduced-commission
 * deal, ไม่หัก = the provider never consumes quota). It is a different thing from
 * "อัตราต่อหน่วย", the PURCHASE price per quota unit in the buy-credit flow — do
 * not mix them up.
 */
export const useTerms = () => {
	const t = useTranslations("terms");
	const CREDIT_QUOTA = isConfig2Project
		? t("creditQuotaConfig2")
		: t("creditQuota");
	const WINNING_QUOTA = isConfig2Project
		? t("winningQuotaConfig2")
		: t("winningQuota");
	return {
		TOTAL_AMOUNT: isConfig2Project ? t("totalAmountConfig2") : t("totalAmount"),
		TOTAL_PAYOFF: isConfig2Project ? t("totalPayoffConfig2") : t("totalPayoff"),
		CREDIT_QUOTA,
		WINNING_QUOTA,
		INITIAL_CREDIT_QUOTA: t("initial", { term: CREDIT_QUOTA }),
		INITIAL_WINNING_QUOTA: t("initial", { term: WINNING_QUOTA }),
		REMAINING_CREDIT_QUOTA: t("remaining", { term: CREDIT_QUOTA }),
		REMAINING_WINNING_QUOTA: t("remaining", { term: WINNING_QUOTA }),
		QUOTA_DEDUCTION_RATE: t("quotaDeductionRate"),
		QUOTA_DEDUCTED: t("quotaDeducted"),
		QUOTA_DEDUCTION_FULL: t("quotaDeductionFull"),
		QUOTA_DEDUCTION_NONE: t("quotaDeductionNone"),
		PER_PROVIDER_HOLD: t("perProviderHold"),
	};
};
